import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  MenuItem,
  FormControl,
  Select,
  Button,
  Switch,
  FormControlLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getUserDetailsAction } from "../../../store/actions/userActions";
import { useFetch } from "../../../hooks";
import { urls } from "../../../urls/urls";
import { BASE_URL_TEST } from "../../../utils/baseUrl";

export default function CompanyTiming() {
  const [startTime1, setStartTime1] = useState("");
  const [startTime2, setStartTime2] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [toggleState, setToggleState] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const loginToken = useSelector((state) => state.user.logintoken);
  const userDetails = useSelector((state) => state.user.userdetails);
  const dispatch = useDispatch();
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const {
    data: activeStatusData,
    isLoading: activeStatusLoading,
    error: activeStatusError,
    fetchData: fetchActiveStatus,
  } = useFetch(BASE_URL_TEST + urls('getActiveStatus'), {
    method: 'POST',
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : '',
      'Content-Type': 'application/json',
    },
  });

  const handleToggle = () => {
    const payload = {
      is_active: toggleState ? 0 : 1,
      vendor_id: userDetails.vendor_id,
    };
    fetchActiveStatus(payload);
  };

  useEffect(() => {
    if (activeStatusData && activeStatusData['status'] === true) {
      const newIsActive = toggleState ? 0 : 1;
      dispatch(getUserDetailsAction({ ...userDetails, is_active: newIsActive }));
    }
  }, [activeStatusData, activeStatusError]);

  const {
    data: timingsData,
    isLoading: timingsLoading,
    error: timingsError,
    fetchData: fetchTimingsData,
  } = useFetch(BASE_URL_TEST + urls("vendorCompanyTimings"), {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  useEffect(() => {
    setStartTime1(userDetails.open_time);
    setStartTime2(userDetails.close_time);
    setTimeZone(userDetails.time_zone);
    setToggleState(userDetails.is_active);
  }, [userDetails]);

  const handleSaveChanges = () => {
    console.log("Start Time 1:", startTime1);
    console.log("Start Time 2:", startTime2);
    console.log("Time Zone:", timeZone);
    console.log("Toggle State:", toggleState ? "1" : "0");
    const saveBody = {
      vendor_id: userDetails.id,
      open_time: startTime1,
      close_time: startTime2,
      time_zone: timeZone,
      is_timezone: toggleState ? "1" : "0",
    };
    fetchTimingsData(saveBody);
  };

  useEffect(() => {
    if (timingsError) {
    } else if (timingsData && timingsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: timingsData["message"],
        status: timingsData["status"],
      });
      setModalOpen(true);
    } else if (timingsData && timingsData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: timingsData["message"],
        status: timingsData["status"],
      });
      setModalOpen(true);
    }
  }, [timingsData, timingsError]);

  //close button
  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "20px",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              marginBottom: "8px",
              marginRight: "10px",
            }}
          >
            Company Timings
          </Typography>
          {!!toggleState && (
            <Typography
              variant="body2"
              sx={{ fontWeight: "bold", color: "green" }}
            >
              Active
            </Typography>
          )}
        </Box>
        <FormControlLabel
          control={
            <Switch
              checked={!!toggleState}
              onChange={handleToggle}
              disabled={activeStatusLoading}
            />
          }
        />
      </Box>
      <Typography variant="body2" sx={{ color: "#666", marginBottom: "20px" }}>
        Set your company's working hours and time zone.
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        <FormControl fullWidth>
          <Typography variant="body2" sx={{ marginBottom: "8px" }}>
            Morning Time
          </Typography>
          <Select
            value={startTime1}
            onChange={(e) => setStartTime1(e.target.value)}
            displayEmpty
            sx={{ height: "40px" }}
          >
            <MenuItem value="" disabled>
              Select morning time
            </MenuItem>
            <MenuItem value="12:00 AM">12:00 AM</MenuItem>
            <MenuItem value="12:30 AM">12:30 AM</MenuItem>
            <MenuItem value="01:00 AM">01:00 AM</MenuItem>
            <MenuItem value="01:30 AM">01:30 AM</MenuItem>
            <MenuItem value="02:00 AM">02:00 AM</MenuItem>
            <MenuItem value="02:30 AM">02:30 AM</MenuItem>
            <MenuItem value="03:00 AM">03:00 AM</MenuItem>
            <MenuItem value="03:30 AM">03:30 AM</MenuItem>
            <MenuItem value="04:00 AM">04:00 AM</MenuItem>
            <MenuItem value="04:30 AM">04:30 AM</MenuItem>
            <MenuItem value="05:00 AM">05:00 AM</MenuItem>
            <MenuItem value="05:30 AM">05:30 AM</MenuItem>
            <MenuItem value="06:00 AM">06:00 AM</MenuItem>
            <MenuItem value="06:30 AM">06:30 AM</MenuItem>
            <MenuItem value="07:00 AM">07:00 AM</MenuItem>
            <MenuItem value="07:30 AM">07:30 AM</MenuItem>
            <MenuItem value="08:00 AM">08:00 AM</MenuItem>
            <MenuItem value="08:30 AM">08:30 AM</MenuItem>
            <MenuItem value="09:00 AM">09:00 AM</MenuItem>
            <MenuItem value="09:30 AM">09:30 AM</MenuItem>
            <MenuItem value="10:00 AM">10:00 AM</MenuItem>
            <MenuItem value="10:30 AM">10:30 AM</MenuItem>
            <MenuItem value="11:00 AM">11:00 AM</MenuItem>
            <MenuItem value="11:30 AM">11:30 AM</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <Typography variant="body2" sx={{ marginBottom: "8px" }}>
            Evening Time
          </Typography>
          <Select
            value={startTime2}
            onChange={(e) => setStartTime2(e.target.value)}
            displayEmpty
            sx={{ height: "40px" }}
          >
            <MenuItem value="" disabled>
              Select evening time
            </MenuItem>
            <MenuItem value="12:00 PM">12:00 PM</MenuItem>
            <MenuItem value="12:30 PM">12:30 PM</MenuItem>
            <MenuItem value="01:00 PM">01:00 PM</MenuItem>
            <MenuItem value="01:30 PM">01:30 PM</MenuItem>
            <MenuItem value="02:00 PM">02:00 PM</MenuItem>
            <MenuItem value="02:30 PM">02:30 PM</MenuItem>
            <MenuItem value="03:00 PM">03:00 PM</MenuItem>
            <MenuItem value="03:30 PM">03:30 PM</MenuItem>
            <MenuItem value="04:00 PM">04:00 PM</MenuItem>
            <MenuItem value="04:30 PM">04:30 PM</MenuItem>
            <MenuItem value="05:00 PM">05:00 PM</MenuItem>
            <MenuItem value="05:30 PM">05:30 PM</MenuItem>
            <MenuItem value="06:00 PM">06:00 PM</MenuItem>
            <MenuItem value="06:30 PM">06:30 PM</MenuItem>
            <MenuItem value="07:00 PM">07:00 PM</MenuItem>
            <MenuItem value="07:30 PM">07:30 PM</MenuItem>
            <MenuItem value="08:00 PM">08:00 PM</MenuItem>
            <MenuItem value="08:30 PM">08:30 PM</MenuItem>
            <MenuItem value="09:00 PM">09:00 PM</MenuItem>
            <MenuItem value="09:30 PM">09:30 PM</MenuItem>
            <MenuItem value="10:00 PM">10:00 PM</MenuItem>
            <MenuItem value="10:30 PM">10:30 PM</MenuItem>
            <MenuItem value="11:00 PM">11:00 PM</MenuItem>
            <MenuItem value="11:30 PM">11:30 PM</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <FormControl fullWidth sx={{ marginBottom: "20px" }}>
        <Typography variant="body2" sx={{ marginBottom: "8px" }}>
          Time Zone
        </Typography>
        <Select
          value={timeZone}
          onChange={(e) => setTimeZone(e.target.value)}
          displayEmpty
          sx={{ height: "40px" }}
        >
          <MenuItem value="" disabled>
            Select time zone
          </MenuItem>
          <MenuItem value="IST">IST</MenuItem>
        </Select>
      </FormControl>
      <Button
        variant="contained"
        onClick={handleSaveChanges}
        sx={{
          backgroundColor: "#007b5e",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#005f47",
          },
        }}
      >
        Save Changes
      </Button>
      {/* Modal Dialog for Success */}
      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
